import PropTypes from "prop-types";
import { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { Button } from "@components/Button";
import { Card } from "../Card";
import { Hero } from "../Hero";
import { Quote } from "../Quote";
import { useEditorials } from "../hooks/useEditorials";
import styles from "./styles/grid.module.css";

export function Grid({ initialEditorials, heroEditorial }) {
  const { editorials, getMoreEditorials, loading, hasMore } = useEditorials(initialEditorials);
  const { ref, inView } = useInView({ threshold: 0 });
  useEffect(() => {
    if (inView) {
      getMoreEditorials();
    }
  }, [inView]);

  return (
    <main>
      <Hero editorial={heroEditorial} />
      <div className={styles.container}>
        {editorials.map((editorial, index) => {
          if (index !== 0 && index % 6 === 0) {
            return (
              <>
                <Quote
                  key={`${editorials[index - 4].key}-${index - 4}`}
                  editorial={editorials[index - 4]}
                />
                <Card key={editorial.key} editorial={editorial} />
              </>
            );
          }
          return <Card key={editorial.key} editorial={editorial} />;
        })}
      </div>
      {/* {hasMore && <div ref={ref} />} */}
      {true && (
        <Button
          description="moreStories"
          descriptionText="Click to load more stories"
          handleClick={getMoreEditorials}
          isLoading={loading}
          full={true}
          variant="secondary"
        >
          More Stories
        </Button>
      )}
    </main>
  );
}

Grid.propTypes = {
  initialEditorials: PropTypes.array.isRequired,
  heroEditorial: PropTypes.object.isRequired,
};
